export const PERIOD_TYPE_OPTIONS = [
  { value: 'config_window', label: 'Configuration Window' },
  { value: 'policy_year', label: 'Policy Year' },
  { value: 'lifetime', label: 'Benefit Lifetime' },
  { value: 'custom', label: 'Custom Period' },
];

export const LIMIT_TYPE_OPTIONS = [
  { value: 'change', label: 'Change' },
  { value: 'upgrade', label: 'Upgrade' },
  { value: 'downgrade', label: 'Downgrade' },
];

export const START_TRIGGER_OPTIONS = [
  { value: 'specific_date', label: 'Specific Date' },
  { value: 'employment_start', label: 'Employment Start' },
  { value: 'benefit_start', label: 'Benefit Start' },
  { value: 'opt_in_date', label: 'Opt In Date' },
];
